import ApiManager from '../api/crud-manager';
import ResultPagination from './result-pagination';
import utils from '../utils';

class OrderHistory {
  constructor(options = {}) {
    this.config = {
      ordersOverview: document.querySelectorAll('[data-module="OrdersOverview"]'),
      orderDetails: document.querySelector('[data-module="OrderDetails"]'),
      overviewItems: 24,
      parameters: {
        page: '1',
        items: '24',
        sort: '',
        customerId: '',
        headersonly: '1',
        type: ''
      },
      ...options
    };
    this.apiManager = new ApiManager();
    this.resultPagination = new ResultPagination();
  }

  init() {
    const { ordersOverview, orderDetails } = this.config;

    if (ordersOverview) {
      ordersOverview.forEach(el => {
        this.renderOrdersOverview(el);
      });
    }

    if (orderDetails) {
      this.renderOrderDetails(orderDetails);
    }
  }

  setPagination(response) {
    this.resultPagination.render('OrdersOverview', response);
  }

  renderOrdersOverview(el) {
    const element = el;
    element.classList.add('is-loading');

    const { overviewItems, parameters } = this.config;
    const { ordersType, apiTemplate, userId, showItems } = element.dataset;

    // set api variables
    parameters.items = overviewItems;
    parameters.template = apiTemplate || 'OrdersOverview';

    if (ordersType) {
      parameters.type = ordersType; // only display headers
    }

    // check for userid
    if (userId) {
      parameters.customerId = userId; // only display headers
    }

    // overwrite items amount for person detail
    if (showItems) {
      parameters.items = showItems; // only display headers
    }

    let url = `/api/v2/catalog/customer/order/history${utils.buildUrlParameters(parameters)}`;

    this.apiManager
      .get(url, 'text/html')
      .then(html => {
        element.innerHTML = html;
        element.classList.remove('is-loading');

        // Get json data to set pagination / filters ect.
        // remove template because bug in IE9
        delete parameters.template;
        url = `/api/v2/catalog/customer/order/history${utils.buildUrlParameters(parameters)}`;
        this.apiManager
          .get(url)
          .then(response => {
            // console.log('cal 2', response);

            this.setPagination(response);
          })
          .catch(() => {
            // console.error(e);
          });
      })
      .catch(() => {
        element.innerHTML = element.dataset.errorMessage || 'orders not available';
        element.classList.remove('is-loading');
        element.classList.add('is-error');
        // console.error(e);
      });
  }

  renderOrderDetails(el) {
    const element = el;
    element.classList.add('is-loading');

    const { orderId } = element.dataset;

    if (orderId) {
      const url = `/api/v2/catalog/customer/order/history?orderNumber=${orderId}&template=OrderDetails`;
      this.apiManager
        .get(url, 'text/html')
        .then(html => {
          element.innerHTML = html;
          element.classList.remove('is-loading');

          // eslint-disable-next-line no-undef
          cart.addEventListener(); // trigger ancient cart module
        })
        .catch(() => {
          element.innerHTML = element.dataset.errorMessage || 'order not available';
          element.classList.remove('is-loading');
          element.classList.add('is-error');
          // console.error(e);
        });
    }
  }
}

export default OrderHistory;
